if(!customElements.get('swym-header-icon')){
class SwymHeaderIcon extends HTMLElement{
    constructor(){
        super();
        if (!window.SwymCallbacks) window.SwymCallbacks = [];
        window.SwymCallbacks.push(this._initializeSwymButton.bind(this));
    }

    async _initializeSwymButton(swat){
        this.button = this.querySelector('button');
        this.button.addEventListener('click', _openWishlistUi);

        function _openWishlistUi(evt){
        swat.ui.open();
        }
        
        // HEADER COUNTER CODE 

        this.counter = this.querySelector(".swym-wishlist-header-counter");
        
        if(this.counter){
        
        // Fetch the lists 
        
        async function getListsData(){
            return new Promise(async (resolve, reject) => {
            swat.fetchLists({
                callbackFn: data => resolve(data), 
                onError: error => reject(error)
            })
            })
        }
        const listData = await getListsData();
        
        // Remove the duplicate occurences of products
        
        let products = {};
        for (const list of listData) {
            for (const product of list.listcontents) {
                const epi = product.epi;
                if (!products[epi]) {
                products[epi] = product;
                }
            }
            }
            this.counter.innerHTML = Object.values(products).length;
        }
    }
}
customElements.define('swym-header-icon', SwymHeaderIcon);
}